import { Router } from '@angular/router';
import { APP_ROUTES_CONFIG, AppRouteConfig } from '@contracts';
import {
  DEFAULT_USER_MANAGEMENT_ROUTES,
  getModuleMenu,
  ModuleStore,
  SessionStore,
} from '@core';
import { environment } from '../../../environments/environment';
import { EMS_ROUTES } from '../../routes/ems.routes';

export const APP_ROUTE_CONFIG_PROVIDER = {
  provide: APP_ROUTES_CONFIG,
  useFactory: (
    moduleStore: ModuleStore,
    router: Router,
    sessionStore: SessionStore,
  ): AppRouteConfig => {
    const modules = [
      // {
      //   id: 'RMS',
      //   label: 'RMS',
      //   icon: 'assets/shared/icons/module/rms.svg',
      //   icon_active: 'assets/shared/icons/module/rms.svg',
      //   type: 'module',
      //   routes: RMS_ROUTES,
      // },
      {
        id: 'EMS',
        label: 'EMS',
        icon: 'assets/shared/icons/module/ems.svg',
        icon_active: 'assets/shared/icons/module/ems.svg',
        type: 'module',
        // disabled: true,
        routes: EMS_ROUTES,
      },
      {
        id: 'user_management',
        label: 'User Management',
        icon: 'assets/shared/icons/module/user-management.svg',
        icon_active: 'assets/shared/icons/module/user-management.svg',
        route: '/user-management',
        type: 'module',
        roles: ['Admin', 'Super Admin'],
        routes: DEFAULT_USER_MANAGEMENT_ROUTES,
      },
    ];

    return {
      siteName: environment.site_name,
      logoPath: 'assets/branding/Frasers Logo.svg',
      version: environment.version,
      package:environment.package,
      defaultRoutes: {
        // RMS: '/dashboard',
        EMS: '/dashboard',
        user_management: '/user-management',
      },
      bg_offline_dashboard: 'assets/branding/bg-offline-dashboard.png',
      moduleRoutes: modules.reduce(
        (acc, m) => ({ ...acc, [m.id]: m.routes }),
        {},
      ),
      module_menu: getModuleMenu(moduleStore, sessionStore, router, modules),
    };
  },
  deps: [ModuleStore, Router, SessionStore],
};
